import { ChevronRight, LogOut, User as UserIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { User } from "@/lib/store/auth-enhanced";
import type { Salon } from "@/lib/store/salon";
import { UserProfileCard } from "../cards/user-profile-card";

interface ProfileSectionProps {
  user: User;
  currentSalon?: Salon | null;
  onProfileClick: () => void;
  onLogout: () => void;
}

export function ProfileSection({
  user,
  currentSalon,
  onProfileClick,
  onLogout,
}: ProfileSectionProps) {
  return (
    <div>
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-4">
        Account
      </h3>

      <UserProfileCard user={user} currentSalon={currentSalon} />

      <div className="grid grid-cols-1 gap-3 mt-4">
        <Button
          variant="ghost"
          onClick={onProfileClick}
          className="h-auto p-2 justify-start hover:bg-muted/50 group"
        >
          <div className="flex items-center space-x-4 w-full">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center group-hover:bg-blue-200 dark:group-hover:bg-blue-800/30 transition-colors">
                <UserIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
              </div>
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-medium text-foreground">Profile & Settings</p>
              <p className="text-xs text-muted-foreground mt-0.5">
                Manage your account and preferences
              </p>
            </div>
            <ChevronRight className="w-4 h-4 text-muted-foreground group-hover:text-foreground" />
          </div>
        </Button>

        <Button
          variant="ghost"
          onClick={onLogout}
          className="h-auto p-4 justify-start hover:bg-red-50 dark:hover:bg-red-900/20 group"
        >
          <div className="flex items-center space-x-4 w-full">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-lg bg-red-100 dark:bg-red-900/20 flex items-center justify-center group-hover:bg-red-200 dark:group-hover:bg-red-800/30 transition-colors">
                <LogOut className="w-5 h-5 text-red-600 dark:text-red-400" />
              </div>
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-medium text-foreground">Sign Out</p>
              <p className="text-xs text-muted-foreground mt-0.5">Log out of your account</p>
            </div>
            <ChevronRight className="w-4 h-4 text-muted-foreground group-hover:text-foreground" />
          </div>
        </Button>
      </div>
    </div>
  );
}
